import { render, staticRenderFns } from "./graph_tonnages_interfaces.vue?vue&type=template&id=bb205ccc"
import script from "./graph_tonnages_interfaces.js?vue&type=script&lang=js&external"
export * from "./graph_tonnages_interfaces.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports